import { isset } from 'utils';
import types from '../types';
import { LISTING_FIRST_PAGE } from '../constants';
import {
    getActiveAdvancedFilterIndex,
    getCurrentPageFromURL,
    getSearchValueFromURL,
    getFiltersInitialStateFromURL,
    getSelectedSortingFromURL
} from '.';

/**
 * @typedef Props
 * @type {Object}
 * @property {types.Filter[]} filters
 * @property {types.AdvancedFilter[]} advancedFilters
 * @property {string} url
 * @property {Object} sorting
 * @property {types.Pagination} pagination
 */

/**
 * @typedef Output
 * @type {Object}
 * @property {types.Filter[]} filters
 * @property {types.AdvancedFilter[]} advancedFilters
 * @property {Array} items
 * @property {string} searchValue
 * @property {string} selectedSorting
 * @property {types.Pagination} pagination
 * @property {boolean} isLoading
 * @property {boolean} isLoadingMore
 * @property {boolean} isSearchLoaderVisible
 */

/**
 * @param {Props} initialData
 * @returns {Output}
 */
const getInitialState = initialData => {
    const { url, sorting } = initialData;

    const filters = getFiltersInitialStateFromURL(initialData.filters, url);

    const index = getActiveAdvancedFilterIndex(
        filters,
        initialData.advancedFilters
    );

    const advancedFilters = isset(index)
        ? getFiltersInitialStateFromURL(
            initialData.advancedFilters[index].items,
            url
        )
        : [];

    const pagination = {
        ...initialData.pagination,
        currentPage: getCurrentPageFromURL(url) || LISTING_FIRST_PAGE
    };

    const selectedSorting =
        getSelectedSortingFromURL(sorting.options, url) || sorting.value;

    const searchValue = getSearchValueFromURL(url);

    return {
        items: [],
        filters,
        advancedFilters,
        searchValue,
        selectedSorting,
        pagination,
        isLoading: true,
        isLoadingMore: false,
        isSearchLoaderVisible: false
    };
};

export default getInitialState;
